import Vue from 'vue'
import { sync } from 'vuex-router-sync'
import App from './components/views/App'
import router from './router'
import store from './store'
import { ClientTable, ServerTable } from 'vue-tables-2'

// Deixa disponível a rota ativa no state do Vuex
sync(store, router)

/**
 * O motivo desse dispatch aqui é
 * por causa do caso onde o usuário
 * sai da tela (através do F5, por exemplo)
 * e store não é atualizado, ou seja, quando
 * a paǵina é carregada automáticamente
 * o popup irá aparecer.
 */
store.dispatch('setHasUnsavedChanges', false)
store.dispatch('cleanGadgetsFilters')

// Internacionalização do sistema
import idioma from '../build/language/index'
import vuexI18n from 'vuex-i18n'
import messagesIn from '../build/language/files/locale-in.json'
import messagesEs from '../build/language/files/locale-es.json'
import messagesPt from '../build/language/files/locale-pt.json'

// Bibliotecas de terceiros
import VeeValidate from 'vee-validate'
import InputTag from 'vue-input-tag'
import VueAnalytics from 'vue-analytics'
import BootstrapVue from 'bootstrap-vue'
import VueCookie from 'vue-cookie'
import Popover from 'vue-js-popover'
import VueHighcharts from 'vue-highcharts'
import Highcharts from 'highcharts'
import loadExporting from 'highcharts/modules/exporting'
import loadGroupedCategories from 'highcharts-grouped-categories'
import loadNoData from 'highcharts-no-data-to-display'
import ToggleButton from 'vue-js-toggle-button'
import moment from 'moment'
import { init as initFullStory, FullStory } from '@fullstory/browser'

Vue.config.productionTip = false

loadExporting(Highcharts)
loadGroupedCategories(Highcharts)
loadNoData(Highcharts)

Vue.use(BootstrapVue)
Vue.use(VeeValidate, {events: 'input'})
Vue.use(VueCookie)
Vue.use(vuexI18n.plugin, store, {
  identifiers: ['%', '%']
})
Vue.use(ClientTable)
Vue.use(ServerTable)
Vue.use(InputTag)
Vue.use(Popover)
Vue.use(VueHighcharts, { Highcharts })
Vue.use(ToggleButton)

// Google Analytics Setup
Vue.use(VueAnalytics, {
  id: 'UA-108229859-1',
  router,
  autoTracking: { pageviewOnLoad: true },
  checkDuplicatedScript: true,
  beforeFirstHit () {
    // console.log('beforeFirstHit!')
    // this is right after the tracker and before every other hit to Google Analytics
  },
  ready () {
    // console.log('ready!')
    // here Google Analaytics is ready to track!
  }
})

initFullStory({ orgId: 'o-1PEET3-na1' })

Vue.prototype.$FullStory = FullStory

Vue.i18n.add('in', messagesIn)
Vue.i18n.add('es', messagesEs)
Vue.i18n.add('pt', messagesPt)

Vue.filter('formatDate', function (value) {
  if (value) {
    return moment().format('DD/MM/YYYY HH:mm:ss')
  }
})

let language = idioma.getCookieByName('language')
if (!language || (language !== 'in' && language !== 'es')) {
  language = 'pt'
}
idioma.changeLanguage(language)

const app = new Vue({
  router,
  store,
  ...App
})

export {
  app,
  router,
  store
}



// WEBPACK FOOTER //
// ./client/app.js